// src/api/users.js
import api from "./axios";

export const getUsers = async () => {
  try {
    const response = await api.get("api/User");
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Kullanıcılar alınamadı!" };
  }
};

export const activateUser = async (id, isActive) => {
  try {
    const response = await api.post("api/User/activate", { id, isActive });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Kullanıcı durumu güncellenemedi!" };
  }
};

export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`api/User/${id}`, userData);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Kullanıcı güncellenemedi!" };
  }
};

export const updatePremium = async (premiumData) => {
  try {
    const response = await api.post("api/User/premium", premiumData);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Premium durumu güncellenemedi!" };
  }
};

export const bulkPremiumUpdate = async (bulkData) => {
  try {
    const response = await api.post("api/User/bulk-premium", bulkData);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Toplu premium güncelleme hatası!" };
  }
};

export const createUser = async (userData) => {
  try {
    const response = await api.post("api/User", userData);
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Kullanıcı oluşturulamadı!" };
  }
};

export const logoutRequest = () => {
  localStorage.removeItem("token");
};

export const getUserInfo = async (userId) => {
  try {
    const response = await api.post("api/Login/user-info", userId, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Kullanıcı bilgileri alınamadı!" };
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await api.post("api/Login/forgot-password", { email });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "Şifre sıfırlama isteği başarısız!" };
  }
};

export const getCities = async () => {
  try {
    const response = await api.post("api/Login/iller");
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "İl listesi alınamadı!" };
  }
};

export const getDistricts = async (cityId) => {
  try {
    const response = await api.post("api/Login/ilceler", { ilId: cityId });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: "İlçe listesi alınamadı!" };
  }
};
